import RollbackIcon from "@mui/icons-material/ReplayRounded";
import { Button } from "@mui/material";
import { useState } from "react";
import type { DataImportTarget } from "../../../../api/types/dataImportTypes";
import ConfirmImportRollbackDialog from "./ConfirmImportRollbackDialog";

interface Props {
  showRollback?: boolean;
  importTarget?: DataImportTarget;
  onRollback: () => void;
}

const ImportDataDetailsActions = ({ showRollback, importTarget, onRollback }: Props) => {
  const [showConfirmRollbackDialog, setShowConfirmRollbackDialog] = useState(false);

  return (
    <>
      {showRollback && (
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<RollbackIcon />}
          onClick={() => setShowConfirmRollbackDialog(true)}
        >
          Rollback Import
        </Button>
      )}

      <ConfirmImportRollbackDialog
        open={showConfirmRollbackDialog}
        importTarget={importTarget}
        onClose={() => setShowConfirmRollbackDialog(false)}
        onConfirm={onRollback}
      />
    </>
  );
};

export default ImportDataDetailsActions;
